import React from 'react';
import { QUIZ_DECOMMISSION_BANNER } from '../quizDecommissionBanner.constants';
import InfoAlert from './InfoAlert';

type Props = { institution?: string };

const QuizDecommissionBanner = ({ institution }: Props) => {
  const key =
    institution && QUIZ_DECOMMISSION_BANNER[institution]
      ? institution
      : 'generic';
  const { title, subtitle } = QUIZ_DECOMMISSION_BANNER[key];

  return (
    <InfoAlert title={title}>
      <div>{subtitle}</div>
    </InfoAlert>
  );
};

export default QuizDecommissionBanner;
